import { getLang } from '../utils/helpers.js';

require('../vendor/slick.min.js');
require('../utils/forms.js');

const API_BASE_URL = process.env.API_BASE_URL;

var $servicesFeedbackForm = $('.js-services-feedback-form'),
    $popupFeedbackMessage = $('.popup_feedback-message');

var validator = $servicesFeedbackForm.validate({
    lang: getLang(),
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      name: {
        required: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
    },
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});

$('.service__slider_1').slick({
    speed: 1000,
    arrows: false,
    dots: true,
    asNavFor: '.service__slider_2',
    touchThreshold: 10,
});

$('.service__slider_2').slick({
    speed: 1000,
    arrows: false,
    fade: true,
    asNavFor: '.service__slider_1',
    touchThreshold: 10,
});

let lang = $('html').attr('lang');

var app = new Vue({
    el: '#services',
    data: {
        tags: [],
        services: [],
        selectedTags: new Set(),
        searchQueryRaw: '',
    },
    delimiters: ['<%','%>'],
    mounted() {
        axios
            .get(`${API_BASE_URL}services/?format=json&servicelanding=${landingId}&lang=${lang}`)
            .then(
                response => {
                    this.services = response.data;
                }
            );
        axios
            .get(`${API_BASE_URL}service-tags/?format=json&servicelanding=${landingId}&lang=${lang}`)
            .then(
                response => {
                    this.tags = response.data.map(({ text }) => text);
                }
            );
    },
    methods: {
        selectTag: function(tag) {
            this.selectedTags = new Set(this.selectedTags.add(tag));
            this.searchQueryRaw = '';
        },
        unselectTag: function(tag) {
            this.selectedTags.delete(tag);
            this.selectedTags = new Set(this.selectedTags);
        },
    },
    computed: {
        searchQuery: function() {
            return this.searchQueryRaw.toLowerCase();
        },
        searchTags: function() {
            if(this.searchQuery){
                let availableTags = new Set(
                    [...this.tags].filter(tag => !this.selectedTags.has(tag))
                );
            
                availableTags = new Set(
                    [...availableTags].filter(
                        tag => tag.toLowerCase().includes(this.searchQuery)
                    )
                );
                return availableTags;
            }
            return new Set();
            
        },
        selectedServices: function() {
            let filteredServices = this.services;
            if(!this.searchQuery && this.selectedTags.size == 0) {
                return filteredServices;
            }
            if(this.selectedTags.size > 0) {
                filteredServices = filteredServices.filter(
                    service => {
                        let tagsConditions =  new Set(
                            [...this.selectedTags].filter(
                                tag => new Set(service.tags).has(tag)
                            )
                        ).size > 0;
                        return tagsConditions;
                    }
                );
            }
            if(this.searchQuery) {
                filteredServices = filteredServices.filter(
                    service => {
                        return service.name.toLowerCase().includes(this.searchQuery) || service.description.toLowerCase().includes(this.searchQuery);
                    }
                );
            }
            return filteredServices;

            // return this.services.filter(
            //     service => {
            //         let filterCondition = true;
            //         if(!this.searchQuery && this.selectedTags.size == 0) {
            //             return filterCondition;
            //         }
            //         let nameIncludes = service.name.toLowerCase().includes(this.searchQuery);
            //         let descriptionIncludes = service.description.toLowerCase().includes(this.searchQuery);
            //         if(this.selectedTags.size > 0) {
            //             let tagsIncludes = new Set(
            //                 [...this.selectedTags].filter(
            //                     tag => new Set(service.tags).has(tag)
            //                 )
            //             ).size > 0;
            //             filterCondition = tagsIncludes;
            //         }
            //         if(this.searchQuery) {
            //             filterCondition = filterCondition || nameIncludes || descriptionIncludes;
            //         }
            //         return filterCondition;
            //     }
            // );
        }
    }
});

$servicesFeedbackForm.submit(function(e){
    let $servicesFeedbackForm = $(this);
    if(validator.valid()){
        let data = $servicesFeedbackForm.serialize();
        app.selectedServices.map(
            service => {
                data += '&services=' + service.id
            }
        );
        $.post(
          $servicesFeedbackForm.attr('action'),
          data,
          function(data){
            if (data.error != true){
                $servicesFeedbackForm[0].reset();
                validator.reset();
                $('.popup-wrapper').fadeIn();
                $popupFeedbackMessage.fadeIn(500);
            }
          }
        );
    }
    return false;
});

$('body').on('click', '.js-service-details-button', function () {
    let $el = $(this);
    $(`#service-popup-${$el.data('popup')}`).fadeIn(500);
    $('.popup-wrapper').fadeIn(300);
});

$('.js-service-button').click(function(e) {
    $('.service-popup').fadeOut(500);
    $('.popup-wrapper').fadeOut(300);
});


// WEBPACK FOOTER //
// ./js/pages/services.js